export const LeadsPage = () => {
  return <h1>Я страница лидов</h1>
}
